import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary, IconButton, List } from "@mui/material";
import { useState } from "react";
import type { OrganizationSideMenu } from "src/layouts/AdminMonitoringLayout";
import NavItem from "src/layouts/SharedLayout/NavBar/NavItem";
import { useAccordionOrganizationMenuStyles } from "src/views/admin/AdminView/admin-monitoring/AccordionOrganizationMenu.styles";

export function AccordionOrganizationMenu({
    icon,
    title,
    defaultOpen,
    organizationList,
}: {
    icon: JSX.Element;
    title: string;
    defaultOpen: boolean;
    organizationList: OrganizationSideMenu[];
}): JSX.Element {
    const classes = useAccordionOrganizationMenuStyles();
    const [expanded, setExpanded] = useState<boolean>(defaultOpen);

    return (
        <Accordion
            expanded={expanded}
            onChange={() => setExpanded(!expanded)}
            className={classes.verticalMargin}
        >
            <AccordionSummary
                expandIcon={
                    <IconButton disableRipple disableFocusRipple>
                        <ExpandMoreIcon />
                    </IconButton>
                }
                aria-controls="panel1a-content"
                id="panel1a-header"
                className={classes.accordion}
            >
                <NavItem disabled={true} depth={0} href="" styledIcon={icon} title={title} />
            </AccordionSummary>
            {expanded && (
                <AccordionDetails className={classes.accordionContent}>
                    <List disablePadding>
                        {organizationList.map((orga, index) => (
                            <NavItem
                                disabled={false}
                                depth={0}
                                href={orga.href}
                                key={`${orga.href}-${index}`}
                                title={orga.title}
                            />
                        ))}
                    </List>
                </AccordionDetails>
            )}
        </Accordion>
    );
}
